export default __webpack_public_path__ + "static/media/bg-panel.69366e1f.webp";